<template>
  <div class="h-full flex-1 overflow-hidden rounded-xl bg-white">
    <SettingsPageFull>
      <template #title>
        <div class="flex space-x-3">
          <span class="text-3xl font-bold capitalize-first">
            {{ $t('navigation.version_notes_title') }}
          </span>
        </div>
      </template>
      <template #body>
        <div class="flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto">
          <ReleaseComponent
            v-for="release in releases"
            :key="release.id"
            :release="release"
          />
          <div v-if="hasMoreReleases" class="flex justify-center pb-3">
            <BaseButton
              :title="$t('attributes.load_more')"
              icon="arrow-down"
              color="secondary"
              is-outline
              :disabled="loadingMore"
              :display-loader="loadingMore"
              @click="loadMoreReleases"
            />
          </div>
        </div>
      </template>
    </SettingsPageFull>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import SettingsPageFull from '@c/SettingsPageFull'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import ReleaseComponent from '@/views/settings/versionNote/component/ReleaseComponent.vue'

export default {
  name: 'TheVersionNoteIndexPage',
  components: {
    BaseButton,
    ReleaseComponent,
    SettingsPageFull
  },
  data() {
    return {
      releases: [],
      pagination: null,
      loadingMore: false,
      setReleaseVersionTimeout: null
    }
  },
  computed: {
    hasMoreReleases() {
      return (
        !!this.pagination &&
        this.pagination.current_page < this.pagination.last_page
      )
    }
  },
  mounted() {
    this.processFetchAllVersionNotesAction({ page: 1 }).then((response) => {
      this.releases = response.releases
      this.pagination = response.pagination ?? null
      this.setReleaseVersionTimeout = setTimeout(() => {
        this.setReleaseNoteAction(response.current_version)
      }, 5000)
    })
  },
  unmounted() {
    clearTimeout(this.setReleaseVersionTimeout)
  },
  methods: {
    loadMoreReleases() {
      this.loadingMore = true
      this.processFetchAllVersionNotesAction({
        page: this.pagination.current_page + 1
      })
        .then((response) => {
          this.releases = [...this.releases, ...response.releases]
          this.pagination = response.pagination ?? null
        })
        .finally(() => {
          this.loadingMore = false
        })
    },
    ...mapActions({
      processFetchAllVersionNotesAction: 'versionNote/fetchAllVersionNotes',
      setReleaseNoteAction: 'auth/updateUserReleaseNoteVersion'
    })
  }
}
</script>
